import {Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ReportsService} from '../reports.service';
import {CallLogsGridComponent} from './call-logs-grid.component';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';

export interface CallLogFilterData {
  filter: any;
}

@Component({
    selector: 'app-call-logs-dialog',
    templateUrl: './call-logs-dialog.component.html',
    standalone: true,
    imports: [FlexModule, MatDialogTitle, MatIconButton, MatDialogClose, MatIcon, CdkScrollable, MatDialogContent, CallLogsGridComponent, MatDialogActions, MatButton, Angular2PromiseButtonModule]
})
export class CallLogsDialogComponent implements OnInit, OnDestroy {

  public opened = false;

  onConfirm: Promise<void>;

  @ViewChild('callLogsGrid') callLogsGrid: CallLogsGridComponent;

  constructor(public reportsService: ReportsService,
              public dialogRef: MatDialogRef<CallLogsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: CallLogFilterData) {
  }

  ngOnInit() {
    console.log('dialog on init');
  }

  ngOnDestroy() {
  }

  async onProcessConfirm() {
    this.onConfirm = this.callLogsGrid.onExportClick();

    await this.dialogRef.close();
  }
}
